export default class MessageRequest {
  message: string

  videoTitle?: string;

  videoUrl?: string;

  constructor(message: string, videoTitle?: string, videoUrl?: string) {
    this.message = message;
    this.videoTitle = videoTitle;
    this.videoUrl = videoUrl;
  }
}
